// src/pages/pengamatan/buah-alami/hooks/usePlotEditDialog.js
import { useState, useEffect } from 'react';
import { database } from "../../../../firebase";
import { ref, update } from "firebase/database";

export const usePlotEditDialog = (onStatusUpdate) => {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [plotStatuses, setPlotStatuses] = useState({});
  const [currentTab, setCurrentTab] = useState('');
  const [loading, setLoading] = useState(false);

  // Buka dialog edit
  const handleOpenEditDialog = (order, tab) => {
    console.log('Opening edit dialog for:', order, 'on tab:', tab);
    setSelectedOrder(order);
    setCurrentTab(tab || '');
    
    // Inisialisasi status plot HANYA untuk plot yang ditampilkan di tab tersebut
    if (order && order.allPlots) {
      const initialStatuses = {};
      
      // Filter plot SAMA PERSIS seperti di tooltip
      let plotsToShow = [];
      switch (tab) {
        case 'Pending':
          plotsToShow = order.allPlots.filter(plot => plot.status_pengamatan === 'Pending');
          break;
        case 'Approved':
          plotsToShow = order.allPlots.filter(plot => plot.status_pengamatan === 'Approved');
          break;
        case 'Processed':
          plotsToShow = order.allPlots.filter(plot => plot.status_pengamatan === 'Processed');
          break;
        case 'Closing':
          plotsToShow = order.allPlots;
          break;
        default:
          plotsToShow = order.allPlots;
      }
      
      // Hanya inisialisasi status untuk plot yang ditampilkan
      plotsToShow.forEach(plot => {
        initialStatuses[plot.plotKey || plot.plot] = plot.status_pengamatan || 'Pending';
      });
      
      setPlotStatuses(initialStatuses);
      console.log(`Initialized ${Object.keys(initialStatuses).length} plots for tab ${tab}`);
    }
    
    setEditDialogOpen(true);
  };

  // Tutup dialog edit
  const handleCloseEditDialog = () => {
    setEditDialogOpen(false);
    setSelectedOrder(null);
    setPlotStatuses({});
    setLoading(false);
  };

  // Handle perubahan status plot
  const handlePlotStatusChange = (plotKey, newStatus) => {
    setPlotStatuses(prev => ({
      ...prev,
      [plotKey]: newStatus
    }));
  };

  // FUNGSI YANG DIPERBAIKI: Handle simpan perubahan ke Firebase TANPA RELOAD
  const handleSavePlotStatuses = async () => {
    if (!selectedOrder) return;

    setLoading(true);
    
    try {
      console.log('Saving plot statuses to Firebase:', plotStatuses);
      console.log('For order:', selectedOrder);
      
      const updates = {};
      let updatedCount = 0;

      // Buat update batch untuk semua plot yang diubah
      Object.keys(plotStatuses).forEach(plotKey => {
        const newStatus = plotStatuses[plotKey];
        
        // Cari plot data untuk mendapatkan status lama
        const plotData = selectedOrder.allPlots.find(plot => 
          (plot.plotKey || plot.plot) === plotKey
        );
        
        if (plotData) {
          const oldStatus = plotData.status_pengamatan;
          
          // Hanya update jika status berubah
          if (oldStatus !== newStatus) {
            // Path Firebase untuk status_pengamatan_per_plot
            const path = `db_freshpine/db_pengamatan/buah_alami/${selectedOrder.pengamatanKey}/plot/${plotKey}/status_pengamatan_per_plot`;
            
            updates[path] = newStatus;
            updatedCount++;
            
            console.log(`Updating plot ${plotKey}: ${oldStatus} → ${newStatus}`);
          }
        }
      });

      // Jika ada perubahan, eksekusi update batch
      if (Object.keys(updates).length > 0) {
        await update(ref(database), updates);
        
        console.log(`Successfully updated ${updatedCount} plots`);
        
        // GUNAKAN TOAST UNTUK PESAN SUKSES - TANPA RELOAD
        if (onStatusUpdate) {
          onStatusUpdate({
            open: true,
            message: `Berhasil menyimpan perubahan status untuk ${updatedCount} plot`,
            severity: "success"
          });
        } else {
          // Fallback jika onStatusUpdate tidak tersedia
          alert(`Berhasil menyimpan perubahan status untuk ${updatedCount} plot`);
        }
        
        // TUTUP DIALOG TANPA RELOAD - data akan otomatis update via Firebase listener
        handleCloseEditDialog();
        
      } else {
        // Tampilkan pesan jika tidak ada perubahan
        if (onStatusUpdate) {
          onStatusUpdate({
            open: true,
            message: "Tidak ada perubahan status yang perlu disimpan",
            severity: "info"
          });
        }
      }
      
    } catch (error) {
      console.error('Error saving plot statuses to Firebase:', error);
      
      // GUNAKAN TOAST UNTUK PESAN ERROR
      if (onStatusUpdate) {
        onStatusUpdate({
          open: true,
          message: "Gagal menyimpan perubahan: " + error.message,
          severity: "error"
        });
      } else {
        alert('Gagal menyimpan perubahan: ' + error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    editDialogOpen,
    selectedOrder,
    plotStatuses,
    currentTab,
    loading,
    handleOpenEditDialog,
    handleCloseEditDialog,
    handlePlotStatusChange,
    handleSavePlotStatuses
  };
};